var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "设置明细表单",
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.dataForm,
            rules: _vm.dataRule,
            "label-width": "160px",
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.dataFormSubmit()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "明细表单", prop: "detailFormId" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { display: "block", "margin-bottom": "10px" },
                  attrs: { placeholder: "明细表单" },
                  model: {
                    value: _vm.dataForm.detailFormId,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "detailFormId", $$v)
                    },
                    expression: "dataForm.detailFormId",
                  },
                },
                _vm._l(_vm.detailFormList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.title, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "表达式", prop: "expression" } },
            [
              _c("el-input", {
                attrs: { placeholder: "表达式" },
                model: {
                  value: _vm.dataForm.expression,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "expression", $$v)
                  },
                  expression: "dataForm.expression",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "排序", prop: "sort" } },
            [
              _c("el-input", {
                attrs: { placeholder: "排序" },
                model: {
                  value: _vm.dataForm.sort,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "sort", $$v)
                  },
                  expression: "dataForm.sort",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.dataFormSubmit()
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }